var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNextIcon = function SvgNextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.833 1.333c.737 0 1.334.597 1.334 1.334v18.666a1.333 1.333 0 0 1-2.667 0V2.667c0-.737.597-1.334 1.333-1.334M1.59.132A1.33 1.33 0 0 1 3 .292L16.333 10.96a1.333 1.333 0 0 1 0 2.082L3 23.708a1.333 1.333 0 0 1-2.167-1.041V1.333c0-.512.294-.98.756-1.201",
    clipRule: "evenodd"
  })));
};
export default SvgNextIcon;